import React from "react";

export default function TranscriptPurgingSettings() {
  return (
    <div className="text-gray-500 text-center py-8">
      Settings will be available soon
    </div>
  );
}